import type { ReactNode } from "react";
import styles from "./PageHeader.module.css";

export function PageHeader({ eyebrow, title, lead, children }: { eyebrow?: string; title: ReactNode; lead?: ReactNode; children?: ReactNode }) {
  return (
    <header className={styles.header}>
      {eyebrow && <p className={styles.eyebrow}>{eyebrow}</p>}
      <h1 className={`${styles.title} engraved`}>{title}</h1>
      <div className="divider" aria-hidden><span /></div>
      {lead && <p className={styles.lead}>{lead}</p>}
      {children}
    </header>
  );
}
